<template>
  <div>
    <span class="back">
      <!-- <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7071 5.79289C16.0976 6.18342 16.0976 6.81658 15.7071 7.20711L10.4142 12.5L15.7071 17.7929C16.0976 18.1834 16.0976 18.8166 15.7071 19.2071C15.3166 19.5976 14.6834 19.5976 14.2929 19.2071L8.29289 13.2071C7.90237 12.8166 7.90237 12.1834 8.29289 11.7929L14.2929 5.79289C14.6834 5.40237 15.3166 5.40237 15.7071 5.79289Z" fill="black"/>
            </svg> -->
      Conditions particulières
    </span>

    <form @submit.prevent="saveEndPrint" class="box">
      <div class="h-10">Informations</div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Numéro</label>
            <input v-model="form.num" type="number" min="0" class="form-control" disabled />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Nom</label>
                <input
                  v-model="form.last_name"
                  type="text"
                  class="form-control"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Prénom(s)</label>
                <input
                  v-model="form.first_name"
                  type="text"
                  class="form-control"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Adresse du souscripteur</label>
            <span class="required">*</span>
            <input
              v-model="form.address_client"
              type="text"
              class="form-control"
              required
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Téléphone</label>
            <input v-model="form.phone" type="text" class="form-control" disabled />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Fax</label>
            <input v-model="form.fax" type="number" min="0" class="form-control" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Activité</label>
            <span class="required">*</span>
            <input v-model="form.activity" type="text" class="form-control" required />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>E-mail</label>
            <input v-model="form.email" type="text" class="form-control" disabled />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Réseau</label>
            <input value="PARTENAIRE" type="text" class="form-control" disabled />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Intermédiare</label>
            <input
              v-model="form.intermediaire"
              type="text"
              class="form-control"
              disabled
            />
          </div>
        </div>
      </div>
      <hr />

      <div class="h-9">Références</div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Numéro de Quittance</label>
            <input
              v-model="form.num_quittance"
              type="text"
              class="form-control"
              disabled
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Numéro de Police</label>
            <input v-model="form.num_police" type="text" class="form-control" disabled />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Emission</label>
            <input :value="new Intl.DateTimeFormat(navigator_language).format(new Date())" type="text" class="form-control" disabled />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Numéro d'Avenant</label>
            <input
              v-model="form.num_avenant"
              type="text"
              class="form-control"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Assuré(e)</label>
            <span class="required">*</span>
            <input v-model="form.assure" type="text" class="form-control" required />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Adresse de l'assuré(e)</label>
            <span class="required">*</span>
            <input v-model="form.address" type="text" class="form-control" required />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
            <div class="form-group">
              <label>Nom & Prénom de l’assureur</label>
              <input
                value="NSIA ASSURANCES"
                type="text"
                class="form-control"
                disabled
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Adresse de l’assureur</label>
              <input
                :value="settings.address_nsia"
                type="text"
                class="form-control"
                disabled
              />
            </div>
          </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Date de saisie</label>
            <input
              readonly
              v-model="form.date_saisie"
              type="date"
              class="form-control"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Effet</label>
            <span class="required">*</span>
            <input v-model="form.date_effet" type="date" class="form-control" required />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Expiration</label>
            <input
              v-model="form.date_expiration"
              type="date"
              class="form-control"
              disabled
            />
          </div>
        </div>
      </div>

      <div class="d-v">Durée : {{ payment.durations?.name }}</div>
      <br />
      <div class="row">
        <div :class="payment.type_engin == '1' ? 'col-md-6' : 'col-md-12'">
          <div class="form-group">
            <label>Branche</label>
            <input value="AUTOMOBILE" type="text" class="form-control" disabled />
          </div>
        </div>
        <div v-if="payment.type_engin == '1'" class="col-md-6">
          <div class="form-group">
            <label>Catégorie</label>
            <select v-model="form.category" class="form-control" disabled>
              <option selected :value="payment.category?.id">
                {{ payment.category.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Mouvement</label>
            <input value="AFFAIRE NOUVELLE" type="text" class="form-control" disabled />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Barème</label>
            <span class="required" v-if="!disablebareme">*</span>
            <input v-model="form.bareme" type="text" class="form-control" required :disabled="disablebareme" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Type de contrat</label>
            <input value="Mono" type="text" class="form-control" disabled />
          </div>
        </div>
      </div>

      <hr />
      <div class="h-9">Identification du véhicule</div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>N° Immatriculation</label>
            <span class="required">*</span>
            <input
              v-model="form.immatriculation"
              type="text"
              class="form-control"
              required
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Date Immatriculation</label>
            <span class="required">*</span>
            <input
              v-model="form.date_immatriculation"
              type="date"
              class="form-control"
              required
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Première mise en circulation</label>
            <input
              v-model="form.first_in_circulation"
              type="date"
              class="form-control"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Genre</label>
            <input v-model="form.genre" type="text" class="form-control" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Marque</label>
            <span class="required">*</span>
            <input
              list="marques"
              type="text"
              v-model="form.marque"
              class="form-control"
              required
            />
          </div>
        </div>
        <datalist id="marques">
          <option
            v-for="(item, key) in payment.marques"
            :key="key"
            :value="item.name"
          ></option>
        </datalist>
        <div class="col-md-6">
          <div class="form-group">
            <label>Modèle</label>
            <span class="required">*</span>
            <input v-model="form.modele" type="text" class="form-control" required />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>N° Série</label>
            <input v-model="form.serie" type="text" class="form-control" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Zone</label>
            <input value="CIMA" type="text" class="form-control" disabled />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Nombre de place</label>
            <input v-model="form.nbr_place" type="text" class="form-control" disabled />
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Energie</label>
            <span class="required">*</span>
            <select v-model="form.energie" type="text" class="form-control" required>
              <option selected v-if="payment.power.fuel_id == '1'" value="1">
                Essence
              </option>
              <option selected v-else value="2">Diesel</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6" v-if="payment.type_engin == 1">
          <div class="form-group">
            <label>Puissance (CV)</label>
            <span class="required">*</span>
            <select v-model="form.puissance" type="text" class="form-control" required>
              <option selected :value="payment.power?.id">
                {{ payment.power.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-6" v-if="payment.type_engin == 2">
          <div class="form-group">
            <label>Puissance réelle (cm³)</label>
            <input
              v-model="form.real_puissance"
              type="number"
              min="0"
              class="form-control"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Charge Utile (Kg)</label>
            <input
              v-model="form.charge_utile"
              type="number"
              min="0"
              class="form-control"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Type Commercial</label>
            <input
              v-model="form.type_commercial"
              type="text"
              class="form-control"
            />
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Valeur à neuf (FCFA-XOF)</label>
            <input
              v-model="form.valeur_neuve"
              type="text"
              class="form-control"
              disabled
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Valeur vénale(FCFA-XOF)</label>
            <input
              v-model="form.valeur_venal"
              type="text"
              class="form-control"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Conducteur Habituel</label>
            <span class="required">*</span>
            <input v-model="form.conducteur" type="text" class="form-control" required />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="float-right">
            <button v-if="loading" disabled class="btn btn-primary">
              Sauvegarder & Imprimer
            </button>
            <button v-else type="submit" class="btn btn-primary">
              Sauvegarder & Imprimer
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { api } from "../../../../helpers/shared";
export default {
  name: "incorporation",
  props: {
    content: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    loading: false,
    disablebareme: false,
    payment: {},
    auth: {},
    form: {
      num: "",
      first_name: "",
      last_name: "",
      address_client: "",
      phone: "",
      fax: "",
      activity: "",
      email: "",
      reseau: "",
      intermediaire: "",
      num_quittance: "",
      num_police: "",
      emission: "",
      num_avenant: "",
      assure: "",
      address: "",
      address_assureur: "",
      date_saisie: "",
      date_effet: "",
      date_expiration: "",
      duree: "",
      branche: "",
      category: "",
      mouvement: "",
      bareme: "",
      type: "",
      immatriculation: "",
      date_immatriculation: "",
      first_in_circulation: "",
      genre: "",
      marque: "",
      modele: "",
      serie: "",
      zone: "",
      nbr_place: "",
      energie: "",
      puissance: "",
      real_puissance: "",
      charge_utile: "",
      type_commercial: "",
      valeur_neuve: "",
      valeur_venal: "",
      conducteur: "",
    },
    durations: [
      {
        id: 1,
        name: "7 jours",
        percentage: 15,
        slug: "7 day"
      },
      {
        id: 2,
        name: "15 jours",
        percentage: 20,
        slug: "15 day"
      },
      {
        id: 3,
        name: "1 mois",
        percentage: 25,
        slug: "1 month"
      },
      {
        id: 4,
        name: "2 mois",
        percentage: 35,
        slug: "2 month"
      },
      {
        id: 5,
        name: "3 mois",
        percentage: 40,
        slug: "3 month"
      },
      {
        id: 6,
        name: "4 mois",
        percentage: 45,
        slug: "4 month"
      },
      {
        id: 7,
        name: "5 mois",
        percentage: 50,
        slug: "5 month"
      },
      {
        id: 8,
        name: "6 mois",
        percentage: 50,
        slug: "6 month"
      },
      {
        id: 9,
        name: "7 mois",
        percentage: 75,
        slug: "7 month"
      },
      {
        id: 10,
        name: "8 mois",
        percentage: 90,
        slug: "8 month"
      },
      {
        id: 11,
        name: "9 mois",
        percentage: 100,
        slug: "9 month"
      },
      {
        id: 12,
        name: "1 an",
        percentage: 100,
        slug: "1 year"
      }
    ],
    categories: [
      { id: 1, name: "Promenades et affaires" },
      { id: 2, name: "Transport pour propre compte" },
      { id: 3, name: "Transport publics des marchandises" },
      { id: 4, name: "Taxi / Transport public de voyageurs" },
      { id: 5, name: "Véhicules d’autoécole" },
      { id: 6, name: "Véhicule de location" },
      { id: 7, name: "Engins à 2 ou 3 roues personnels" },
      { id: 8, name: "Engins à 2 ou 3 roues utilisée comme taxi" },
    ],
    categoriesIntermediares: [
      { id: 1, name:'COURTIERS' },
      { id: 2, name:'BUREAUX DIRECTS' },
      { id: 3, name:'FORCE DE VENTE' },
      { id: 4, name:'BANCASSURANCE' },
      { id: 5, name:'PARTENAIRES' },
      { id: 6, name:'AGENCE GENERALE' },
    ],
    navigator_language: '',
  }),
  created() {
    this.payment = JSON.parse(this.content);
    console.log(this.payment)
    if(this.payment.durations?.name === '1 an') {
      this.form.bareme = 'Ferme'
      this.disablebareme = true
    } else if(this.payment.durations?.name === '6 mois' && (!this.payment.subscription.category_id === 4 || !this.payment.data.category === 4 || !this.payment.category.id === 4)) {
      this.form.bareme = 'Prorata'
      this.disablebareme = true
    }
  },
  async mounted() {
    this.navigator_language = navigator.language
    this.form.emission = new Intl.DateTimeFormat('en-US').format(new Date())

    const { data } = await axios.get(`/api/subscription/${this.payment.uuid}`)
    this.form.num = data?.id

    this.form.num_avenant = '000000A'
    this.form.reseau = 'PARTENAIRE'
    this.form.type = 'Mono'
    this.form.zone = 'CIMA'
    this.form.mouvement = 'AFFAIRE NOUVELLE'
    this.form.branche = 'AUTOMOBILE'

    const category = this.getCategory(this.payment.subscription.category_id)
    this.auth = JSON.parse(localStorage.getItem('auth')).user

    const categorieIntermediaire = this.getIntermediaireCategory(this.auth?.id_categorie_intermediaire)

    if(this.auth?.last_name && this.auth?.first_name) {
      this.form.intermediaire = `${this.auth.last_name} ${this.auth.first_name}`
    } else if(this.auth?.nom_entreprise) {
      this.form.intermediaire = this.auth.nom_entreprise
    } else if(this.auth?.name) {
      this.form.intermediaire = this.auth.name
    }
    
    this.form.num_quittance = this.payment.subscription.num_quittance || localStorage.getItem('num_quittance') || await this.generateNumQuittance()

    this.form.num_police = this.payment.subscription.num_police || await this.generateNumPolice(categorieIntermediaire.name, category.name)

    if (Object.entries(this.payment.data).length !== 0) {
      this.form = { ...this.form, ...this.payment.data };
      if (!this.form.nbr_place) {
        this.form.nbr_place = this.payment.subscription.number_of_seats_in_the_vehicle;
      }
    } else {
      this.form.first_name = this.payment.subscription.client_firstname;
      this.form.last_name = this.payment.subscription.client_name;
      this.form.phone = this.payment.user.phone;
      this.form.email = this.payment.subscription.client_email;
      this.form.address_assureur = this.settings.address_nsia || 'Rue Brazza derrière la grande poste';
      this.form.date_saisie = this.payment.date_saisie;
      this.form.date_expiration = `${new Date(this.payment.date_expiration).setDate(new Date(this.payment.date_expiration).getDate() - 1)}`;
      
      if(!this.payment.durations) {
        this.payment.durations = this.durations.find(el => el.slug === this.payment.subscription.duration_of_insurance)
      }

      this.form.duree = this.payment.durations?.id;

      if (this.payment.type_engin == "1") {
        this.form.category = this.payment.subscription.category_id;
      }
      this.form.nbr_place = this.payment.subscription.number_of_seats_in_the_vehicle;
      this.form.energie = this.payment.power.fuel_id;
      this.form.puissance = this.payment.type_engin == 1 ? this.payment.power?.id : '';
      this.form.real_puissance = this.payment.type_engin == 2 ? this.payment.power?.id : ''
      this.form.valeur_neuve = this.payment.subscription.valeur_neuve;
      this.form.valeur_venal = this.payment.subscription.valeur_venal;
    }
  },
  watch: {
    'form.date_effet': function (newValue, oldValue) {
      const effetDate = new Date(newValue);
    
      effetDate.setDate(effetDate.getDate() - 1);
      
      let year;
      let month;
      let day;

      const number = Number(this.payment.durations?.name.split(' ')[0])
      
      if(this.payment.durations?.name.includes("an")) {
        year = effetDate.getFullYear() + number;
        month = (effetDate.getMonth() + 1).toString().padStart(2, '0');

        const daysInMonth = new Date(year, month, 0).getDate()

        day = effetDate.getDate() % daysInMonth === 0 ? daysInMonth : effetDate.getDate().toString().padStart(2, '0')
        
      } else if(this.payment.durations?.name.includes("mois")) {
        year = effetDate.getMonth() + 1 + number > 12 ? effetDate.getFullYear() + 1 : effetDate.getFullYear();
        month = ((effetDate.getMonth() + 1 + number) % 12).toString().padStart(2, '0');

        const daysInMonth = new Date(year, month, 0).getDate()

        day = effetDate.getDate() % daysInMonth === 0 ? daysInMonth : effetDate.getDate().toString().padStart(2, '0')
        
      } else if(this.payment.durations?.name.includes("jours")) {
        effetDate.setDate(effetDate.getDate() + number)

        year = effetDate.getFullYear()
        month = (effetDate.getMonth() + 1).toString().padStart(2, '0')
        day = effetDate.getDate().toString().padStart(2, '0')
      }

      this.form.date_expiration = `${year}-${month}-${day}`;
    }
  },
  methods: {
    getCategory(id) {
      return this.categories.find((el) => el?.id === id) ?? '';
    },
    getIntermediaireCategory(id) {
      return this.categoriesIntermediares.find((el) => el?.id === id) ?? '';
    },
    async generateNumQuittance() {
      const now = new Date()
      const month = (now.getMonth() + 1).toString().padStart(2, '0')
      const year = now.getFullYear().toString().slice(-2)

      let num_quittance = `TG${month}${year}`

      let randomNumber = String(Math.floor(Math.random() * 1000000000)).padStart(9, '0')
      
      let response = await axios.get(`/api/check-random-number/${randomNumber}/${now.getFullYear().toString()}/${month}`)

      while (response.data.exists) {
        randomNumber = String(Math.floor(Math.random() * 1000000000)).padStart(9, '0')

        response = await axios.get(`/api/check-random-number/${randomNumber}/${now.getFullYear().toString()}/${month}`)
      }

      const { data } = await axios.post('/api/save-random-number', { random_number: randomNumber })

      if(data.data) {
        num_quittance += `${randomNumber}APP`
        localStorage.setItem('num_quittance', num_quittance)
      }

      if(num_quittance) {
        await axios.put(`/api/subscription/num-quittance/${this.payment.uuid}`, { num_quittance })
      }

      return num_quittance
    },
    async generateNumPolice(categorieIntermediaire, categorieUsage) {
      let num_police = ''

      if(this.payment.subscription.sale_code) {
        num_police += this.payment.subscription.sale_code
      } else {
        if(!this.auth.sale_code) {
          switch(categorieIntermediaire) {
            case 'BUREAUX DIRECTS':
              num_police += '2000'
              break
            case 'COURTIERS':
              num_police += '1000'
              break
            case 'FORCE DE VENTE':
              num_police += '9000'
              break
            case 'BANCASSURANCE':
              num_police += '9000'
              break
            case 'PARTENAIRES':
              num_police += '8000'
              break
            case 'AGENCE GENERALE':
              num_police += '3000'
              break
          }
        } else {
          num_police += this.auth.sale_code
        }
      }

      switch(categorieUsage) {
        case 'Promenades et affaires':
          num_police += '201'
          break
        case 'Transport pour propre compte':
          num_police += '202'
          break
        case 'Transport publics des marchandises':
          num_police += '203'
          break
        case 'Taxi / Transport public de voyageurs':
          num_police += '204'
          break
        case 'Véhicules d’autoécole':
          num_police += '205'
          break
        case 'Véhicule de location':
          num_police += '206'
          break
        default:
          num_police += '200'
          break
      }

      num_police += new Date().getFullYear().toString().slice(-2)
      
      const { data } = await axios.get('/api/serial-number/1')

      let currentSerial = Number(localStorage.getItem('serial_number')) || Number(data.serial_number)
      localStorage.setItem('serial_number', currentSerial)

      if(currentSerial === Number(data.serial_number)) await axios.put('/api/serial-number', { serial_number: currentSerial + 1 })
      
      const now = new Date()
      
      if(now.getMonth() === 0 && now.getDate() === 1) {
        currentSerial = 0
        await axios.put('/api/serial-number', { serial_number: 0 })
      }

      const serial = currentSerial.toString().padStart(6, '0')

      num_police += serial

      if(num_police) {
        await axios.put(`/api/subscription/num-police/${this.payment.uuid}`, { num_police })
      }

      return num_police
    },
    saveEndPrint() {
      this.loading = true;
      axios
        .post(api("administration/contract/" + this.payment.uuid + "/incorporation"), this.form, {
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.payment.uuid + ".pdf");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          this.loading = false;

          location.href = `/administration/contract/${this.payment.uuid}/auto`
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  //cursor: pointer;
  color: #5e5873;
  font-size: 20px;
  margin-bottom: 20px;
  display: inline-block;
}
.box {
  width: 80%;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 4px;
  min-height: 100px;
  height: auto;
  padding: 10px;
}
.h-10 {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 20px;
}
.h-9 {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 15px;
}
.mtk-row {
  display: flex;
  flex-direction: row;
  gap: 20px;
}
hr {
  opacity: 0.8;
}
.p-t {
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 18px;
}
.d-v {
  font-weight: bold;
  color: #002a85;
}
.required {
  color: red;
}
</style>
